export var PublisherAllowListArchivedStatus;
(function (PublisherAllowListArchivedStatus) {
    PublisherAllowListArchivedStatus["ACTIVE"] = "Active";
    PublisherAllowListArchivedStatus["ARCHIVED"] = "Archived";
    PublisherAllowListArchivedStatus["BOTH"] = "Both";
})(PublisherAllowListArchivedStatus || (PublisherAllowListArchivedStatus = {}));
//# sourceMappingURL=types.js.map